// import horizontalScroll_mix from '@/components/HorizolnalScroller/horizontalScroll_mix'
// mixins: [horizontalScroll_mix],

const horizontalScroll_mix = {
  data() {
    return {
      hscrl_mousedown: false,
      hscrl_startX: 0,
      hscrl_innerScrollLeft: 0,
      // hscrl_surface: {
      // timestamp: 0,
      // ist_to: true,
      // ist_bottom: true,
      // ist_left: true,
      // ist_right: true,
      // },
      hscrl_surface: null,
    }
  },
  methods: {
    hscrl_dragScrollRmEventListeners() {
      window.removeEventListener('mouseup', this.hscrl_dragScrollMouseup)
      window.removeEventListener('mousemove', this.hscrl_dragScrollMousemove)
    },
    hscrl_dragScrollAddEventListeners() {
      window.addEventListener('mouseup', this.hscrl_dragScrollMouseup)
      window.addEventListener('mousemove', this.hscrl_dragScrollMousemove, { passive: false })
    },
    hscrl_dragScrollMouseup() {
      this.hscrl_mousedown = false
      this.hscrl_dragScrollRmEventListeners()
    },
    hscrl_dragScrollMousedown(e) {
      // console.log('handleMousedown', e)
      // if (!this.hasDragscroll) return
      const { hscrl_inner } = this.$refs
      if (!hscrl_inner) return
      this.hscrl_startX = e.pageX - hscrl_inner.offsetLeft
      this.hscrl_innerScrollLeft = hscrl_inner.scrollLeft

      this.hscrl_mousedown = true
      this.hscrl_dragScrollAddEventListeners()
    },
    hscrl_dragScrollMousemove(e) {
      // console.log('mousemove', e)
      if (this.hscrl_mousedown) {
        e.preventDefault()
        const { hscrl_inner } = this.$refs
        const x = e.pageX - hscrl_inner.offsetLeft
        const walk = (x - this.hscrl_startX) * 1.5
        const scrollLeft = this.hscrl_innerScrollLeft - walk
        hscrl_inner.scrollLeft = scrollLeft
      }
    },
    hscrl_wheelScroll(e, useCurrenTarget = true) {
      // console.log(e)
      e.preventDefault()
      const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX

      let el = null
      // if (useCurrenTarget) {
      el = e.currentTarget
      // }
      // console.log(el)
      this.hscrl_scroll(delta, el)
    },
    hscrl_scroll(num, element) {
      const el = element || this.$refs.hscrl_inner
      if (el) {
        el.scrollLeft += num
      }
    },
    hscrl_handleTouchend(e) {
      const scroller = e.currentTarget
      if (!scroller) return
      // add info on event for parent handling swipe events
      const timestamp = Date.now()
      const ist_top = scroller.scrollTop <= 0
      const ist_bottom = scroller.scrollTop >= scroller.scrollHeight - scroller.clientHeight
      const ist_left = scroller.scrollLeft <= 0
      const ist_right = scroller.scrollLeft >= scroller.scrollWidth - scroller.clientWidth

      const ist_top_time =
        this.hscrl_surface?.ist_to === ist_top ? this.hscrl_surface.ist_top_time || 0 : timestamp
      const ist_bottom_time =
        this.hscrl_surface?.ist_bottom === ist_bottom
          ? this.hscrl_surface.ist_bottom_time || 0
          : timestamp
      const ist_left_time =
        this.hscrl_surface?.ist_left === ist_left
          ? this.hscrl_surface.ist_left_time || 0
          : timestamp
      const ist_right_time =
        this.hscrl_surface?.ist_right === ist_right
          ? this.hscrl_surface.ist_right_time || 0
          : timestamp

      const surface = {
        timestamp,
        ist_first: !this.hscrl_surface,
        ist_top,
        ist_bottom,
        ist_left,
        ist_right,
        ist_top_time,
        ist_bottom_time,
        ist_left_time,
        ist_right_time,
      }

      this.hscrl_surface = surface
      e.gw_touchends = [...(e.gw_touchends || []), surface]
    },
    // --- legacy
    wheelScroll(e, useCurrenTarget = true) {
      // console.log(e)
      e.preventDefault()
      const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX

      let el = null
      // if (useCurrenTarget) {
      el = e.currentTarget
      // }
      // console.log(el)
      this.scroll(delta, el)
    },
    scroll(num, element) {
      const el = element || this.$refs.scroll_container // hscrl_inner
      if (el) {
        el.scrollLeft += num
      }
    },
  },
}

export default horizontalScroll_mix
